<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '80%'"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PLANNING_OPERATION_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.groundContext.planningOperation;
          // this.entry.addressAttributes = response.data.accountContext.address;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(planningOperation) {
      // console.log("planningOperation", planningOperation, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(planningOperation, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_PLANNING_OPERATION_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(planningOperation, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createPlanningOperation.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_PLANNING_OPERATION_QUERY = gql `
  {
    groundContext {
      planningOperation {
        id        
        operationTypeId
        operationType {
          id
          name
          kind
        }
        periodIds
        periodIdsAttribute
        periods {
          id
          name
        }
        operationDate
        observation
        activitiesAttributes {
          id
          personId
          person {
            id
            name
          }
          durationInHours
          durationInMinutes
          durationText
          patrimonyId
          patrimony {
            id
            description
          }
          implementId
          implement {
            id
            description
          }
          validations
        }
        dummyExitMovementItemsAttributes {
          id
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
          }
          packaging {
            id
            name
          }
          storage {
            id
            name
          }
          hasCropLimit
          unitQuantity
          quantity
          totalPrice
          validations
        }
        dummyEntryMovementItemsAttributes {
          id
         	itemId
          item {
            id
            name
            unit {
              id
              name
            }
          }
          quantity
          expectedUnitPrice
          price
          storageId
          storage {
            id
            name
          }
          validations
        }
        validations
      }
    }
    accountGlobalSharedContext {
      allOperationTypes {
        id
        name
        operationOrder
        kind
      }
    }
  }
`;

const CREATE_PLANNING_OPERATION_MUTATION = gql `
  mutation($input: PlanningOperationCreateInputObject!) {
    createPlanningOperation(input: $input) {
      planningOperation {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
